<script setup lang="ts">
import { TabsList, type TabsListProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<TabsListProps & { class?: string }>()
</script>

<template>
	<TabsList
		v-bind="props"
		:class="
			cn(
				// 'bg-muted text-muted-foreground inline-flex h-[40px] items-center justify-center rounded-md p-4px',
				'bg-muted text-muted-foreground h-[60px] items-center justify-center rounded-md',
				props.class,
			)
		"
	>
		<slot />
	</TabsList>
</template>
